/* Retained components: desktop header/mega, chat, scratch popup, cart drawer.
   Isolated from the retired full-site and PDP behavior layers.
   v3 20261018 (099 wave 1, milestone 4): the desktop cart drawer no longer computes the
   free-shipping gap itself. It calls window.dnFsCompute(cart) from
   dn-free-shipping-progress-v4.js (the single place the gap is computed, same basis as the
   v43 drawer) and formats money with window.themeFormatMoney (the v43 formatter), so it
   follows the visitor currency. The free-gift milestone (a hard-coded $150 constant with no
   matching store rule) and the hard-coded 79 threshold fallback are removed. */
(function () {
  'use strict';
  if (window.__DN3_RETAINED_COMPONENTS__) return;
  window.__DN3_RETAINED_COMPONENTS__ = true;
  var mq = window.matchMedia('(min-width: 1024px)');

  /* v4 (099 2f, ENGINE-CONTRACT §6.8): requests keep the market prefix via window.dnRoute (progress-v5); shop root if missing. */
  function route(path) { return typeof window.dnRoute === 'function' ? window.dnRoute(path) : '/' + path; }
  function $(s, r) { return (r || document).querySelector(s); }
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ENGINE-CONTRACT §6.5: parts the skin keeps visible on an empty bag, declared on the drawer root. */
  function emptyKeeps(drawer, part) {
    var v = drawer && drawer.getAttribute ? drawer.getAttribute('data-cart-empty-keep') : null;
    return !!v && (',' + v.replace(/\s+/g, '') + ',').indexOf(',' + part + ',') > -1;
  }

  function apply() { document.body.classList.toggle('dn3-retained-on', mq.matches); }

  /* ── cart badge mirror ── */
  function cartBadge() {
    var src = $('.site-header [data-cart-count]'), out = $('[data-dn3-cart-n]');
    if (!src || !out) return;
    function run() {
      var n = (src.textContent || '').trim();
      var vis = src.style.display !== 'none' && n && n !== '0';
      out.textContent = n;
      out.style.display = vis ? 'flex' : 'none';
    }
    run();
    new MutationObserver(run).observe(src, { childList: true, characterData: true, subtree: true, attributes: true });
  }

  /* ── mega menu open / close on hover ── */
  function megaInit() {
    var wrap = $('.dn3-hd__navwrap'); if (!wrap) return;
    var closeTimer = null;
    function closeAll() {
      wrap.classList.remove('is-mega-open');
      $all('.dn3-mega', wrap).forEach(function (m) { m.classList.remove('is-on'); });
      $all('.dn3-hd__navitem', wrap).forEach(function (i) { i.classList.remove('is-open'); });
    }
    $all('.dn3-hd__navitem[data-dn3-mega-for]', wrap).forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        if (!mq.matches) return;
        clearTimeout(closeTimer);
        closeAll();
        var id = item.getAttribute('data-dn3-mega-for');
        var mega = $('[data-dn3-mega="' + id + '"]', wrap);
        if (mega) { wrap.classList.add('is-mega-open'); mega.classList.add('is-on'); item.classList.add('is-open'); }
      });
      item.addEventListener('mouseleave', function () { closeTimer = setTimeout(closeAll, 180); });
    });
    $all('.dn3-mega', wrap).forEach(function (mega) {
      mega.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      mega.addEventListener('mouseleave', function () { closeTimer = setTimeout(closeAll, 180); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    if (mq.addEventListener) mq.addEventListener('change', function (e) { if (!e.matches) closeAll(); });
  }

  /* ── DW chat: stamp opens the card (reuses the real chat backend); no scroll lock on desktop ── */
  function dwInit() {
    var stamp = $('[data-dn3-dw]'), fab = $('#dn2-chat-fab'), sheet = $('#dn2-chat');
    if (!stamp || !fab || !sheet) return;
    /* badge state sync (hidden once seen, same as the fab badge) */
    var srcBadge = fab.querySelector('[data-chat-badge]');
    var myBadge = $('[data-dn3-dw-badge]', stamp);
    function syncBadge() { if (myBadge && srcBadge) myBadge.style.display = srcBadge.style.display === 'none' ? 'none' : 'flex'; }
    syncBadge();
    if (srcBadge) new MutationObserver(syncBadge).observe(srcBadge, { attributes: true });
    /* opening chat on desktop does not lock page scroll (lock + unlock makes the page jump):
       DN2.openSheet is patched — on desktop the chat sheet opens the card directly, without the body lock */
    if (window.DN2 && window.DN2.openSheet && !window.DN2.__dn3ChatPatch) {
      var __origOpen = window.DN2.openSheet;
      window.DN2.openSheet = function (sh) {
        if (mq.matches && sh && sh.id === 'dn2-chat') {
          sh.classList.add('is-open');
          sh.setAttribute('aria-hidden', 'false');
          try { sh.dispatchEvent(new CustomEvent('dn2:open', { bubbles: true })); } catch (e) {}
          return;
        }
        return __origOpen(sh);
      };
      window.DN2.__dn3ChatPatch = true;
    }
    stamp.addEventListener('click', function () {
      fab.click(); /* real chat: badge clear + history load + polling all use the original logic */
    });
    /* desktop details: dateline + placeholder + status copy */
    function dateline() {
      var el = $('[data-dn3-dw-date]'); if (!el) return;
      var d = new Date();
      var day = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][d.getDay()];
      var h = d.getHours();
      var part = h < 12 ? 'morning' : (h < 18 ? 'afternoon' : 'evening');
      el.textContent = day + ' ' + part + ' —';
    }
    dateline();
    var input = sheet.querySelector('[data-chat-input]');
    /* IME guard: Enter while composing (isComposing / keyCode 229) confirms the candidate, it does not send
       (the capture phase runs before the original send listener; after interception the composition lands in the input normally) */
    document.addEventListener('keydown', function (e) {
      if (!mq.matches) return;
      if (e.key === 'Enter' && (e.isComposing || e.keyCode === 229) && e.target === input) {
        e.stopPropagation();
      }
    }, true);
    function placeholder() { if (input) input.placeholder = mq.matches ? 'Seal your note…' : 'Write a message…'; }
    placeholder();
    if (mq.addEventListener) mq.addEventListener('change', placeholder);
  }

  /* ── hang-tag mini gold foil + click forwarding ── */
  var REVEAL_KEY = 'dn3PopRevealed';
  function popRevealed() { try { return localStorage.getItem(REVEAL_KEY) === '1'; } catch (e) { return false; } }
  function markPopRevealed() {
    try { localStorage.setItem(REVEAL_KEY, '1'); } catch (e) {}
    var tg = $('[data-dn3-tag]');
    if (tg) tg.classList.add('is-revealed');
  }
  function tagInit() {
    var tag = $('[data-dn3-tag]'); if (!tag) return;
    var canvas = $('.dn3-tag__foil', tag);
    if (popRevealed()) tag.classList.add('is-revealed');
    function paint() {
      if (!canvas || !mq.matches) return;
      var r = canvas.getBoundingClientRect();
      if (!r.width) { requestAnimationFrame(paint); return; }
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(r.width * dpr); canvas.height = Math.round(r.height * dpr);
      var ctx = canvas.getContext('2d'); ctx.scale(dpr, dpr);
      goldFoil(ctx, r.width, r.height, 7.5);
    }
    paint();
    window.addEventListener('resize', paint);
    tag.addEventListener('click', function () {
      var opener = $('.dn-pop__tab[data-dn-open]');
      if (opener) opener.click();
    });

    /* hover auto-scratch preview (design tabEnter / tabLeave, parameters copied as is) */
    var win = $('.dn3-tag__win', tag);
    var flakeLayer = null;
    if (win) {
      flakeLayer = document.createElement('span');
      flakeLayer.setAttribute('aria-hidden', 'true');
      flakeLayer.style.cssText = 'position:absolute;inset:0;overflow:visible;pointer-events:none;z-index:3;';
      win.appendChild(flakeLayer);
    }
    function tabFlake(x, y) {
      if (!flakeLayer) return;
      var pal = ['#D8C6A2', '#C4AF88', '#E6D9BE', '#B69C6F'];
      var f = document.createElement('span');
      var w = 2 + Math.random() * 3, h = 3 + Math.random() * 5;
      f.style.cssText = 'position:absolute;left:' + (x - w / 2) + 'px;top:' + (y - h / 2) + 'px;width:' + w + 'px;height:' + h + 'px;background:' + pal[(Math.random() * 4) | 0] + ';border-radius:1px;';
      flakeLayer.appendChild(f);
      var dx = (Math.random() - 0.5) * 40, dy = 18 + Math.random() * 34, rot = (Math.random() - 0.5) * 360;
      var anim = f.animate([
        { transform: 'translate(0,0) rotate(0)', opacity: 1 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) rotate(' + rot + 'deg)', opacity: 0 }
      ], { duration: 500 + Math.random() * 300, easing: 'cubic-bezier(0.3,0.7,0.4,1)' });
      anim.onfinish = function () { f.remove(); };
    }
    var tabRaf = null;
    function scratchIn() {
      if (!canvas || !mq.matches) return;
      if (tabRaf) cancelAnimationFrame(tabRaf);
      var r = canvas.getBoundingClientRect();
      var w = r.width, h = r.height;
      var ctx = canvas.getContext('2d');
      ctx.globalCompositeOperation = 'destination-out';
      var pts = [], N = 40;
      for (var i = 0; i <= N; i++) {
        var t = i / N;
        pts.push({ x: 8 + t * (w - 16), y: h * 0.5 + Math.sin(t * Math.PI * 2.2) * (h * 0.26) });
      }
      var dur = 560, start = performance.now(), last = 0;
      function step(now) {
        var p = Math.min(1, (now - start) / dur);
        var idx = Math.min(pts.length - 1, Math.floor(p * pts.length));
        for (var i = last; i <= idx; i++) {
          var pt = pts[i]; if (!pt) continue;
          popStamp(ctx, pt.x, pt.y, 10);
          if (i % 2 === 0) tabFlake(pt.x, pt.y);
        }
        last = idx + 1;
        if (p < 1) tabRaf = requestAnimationFrame(step); else tabRaf = null;
      }
      tabRaf = requestAnimationFrame(step);
    }
    function scratchOut() {
      if (tabRaf) { cancelAnimationFrame(tabRaf); tabRaf = null; }
      paint();
    }
    tag.addEventListener('mouseenter', function () { if (!tag.classList.contains('is-revealed')) scratchIn(); });
    tag.addEventListener('mouseleave', function () { if (!tag.classList.contains('is-revealed')) scratchOut(); });
  }

  /* soft-edged scratch stamp (design _popStamp parameters: soft core 0.52 + 6 random specks) */
  function popStamp(ctx, x, y, r) {
    var g = ctx.createRadialGradient(x, y, r * 0.52, x, y, r);
    g.addColorStop(0, 'rgba(0,0,0,1)'); g.addColorStop(0.82, 'rgba(0,0,0,0.9)'); g.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = g; ctx.beginPath(); ctx.arc(x, y, r, 0, 6.283); ctx.fill();
    for (var i = 0; i < 6; i++) {
      var a = Math.random() * 6.283, d = r * (0.5 + Math.random() * 0.65), cr = r * (0.12 + Math.random() * 0.28);
      ctx.fillStyle = 'rgba(0,0,0,' + (0.45 + Math.random() * 0.55) + ')';
      ctx.beginPath(); ctx.arc(x + Math.cos(a) * d, y + Math.sin(a) * d, cr, 0, 6.283); ctx.fill();
    }
  }

  /* Gold foil wording belongs to each skin's layout; the existing DUNIII skin keeps the same canvas text. */
  function goldFoil(ctx, w, h, fs) {
    ctx.globalCompositeOperation = 'source-over';
    var g = ctx.createLinearGradient(0, 0, w, h);
    g.addColorStop(0, '#D9C79E'); g.addColorStop(0.35, '#C9B694'); g.addColorStop(0.55, '#E3D3AC'); g.addColorStop(0.8, '#C2AD87'); g.addColorStop(1, '#D5C29A');
    ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
    ctx.fillStyle = 'rgba(120, 98, 62, 0.5)';
    ctx.font = '700 ' + fs + 'px Lato, sans-serif';
    ctx.textBaseline = 'middle';
    var brand = ((document.body && document.body.getAttribute('data-scratch-brand')) || '').trim();
    var word = (brand ? brand + ' · ' : '') + 'SCRATCH TO REVEAL · ';
    var tw = ctx.measureText(word).width;
    ctx.save(); ctx.rotate(-0.06);
    for (var row = 0, y = -h * 0.2; y < h * 1.4; y += fs * 2.2, row++) {
      for (var x = -tw + (row % 2) * (tw / 2) - w * 0.2; x < w * 1.3; x += tw) ctx.fillText(word, x, y);
    }
    ctx.restore();
  }

  /* ── gold card: after opening, repaint paintFoil's black foil as gold (scratch mechanism kept); manage the DRAG hint ── */
  function popInit() {
    var root = $('[data-dn-pop]'); if (!root) return;
    var canvas = root.querySelector('[data-dn-scratch]');
    var drag = $('[data-dn3-pop-drag]', root);
    function regold() {
      if (!mq.matches || !canvas) return;
      var r = canvas.getBoundingClientRect(); if (!r.width) return;
      var ctx = canvas.getContext('2d');
      ctx.save(); ctx.setTransform(1, 0, 0, 1, 0, 0);
      var dpr = canvas.width / r.width;
      ctx.scale(dpr, dpr);
      ctx.globalCompositeOperation = 'source-over';
      goldFoil(ctx, r.width, r.height, 11);
      ctx.restore();
      if (drag) drag.style.display = 'inline-flex';
    }
    new MutationObserver(function () {
      if (root.classList.contains('is-open')) { setTimeout(regold, 90); setTimeout(regold, 350); }
    }).observe(root, { attributes: true, attributeFilter: ['class'] });
    /* ── desktop scratch feel (design _popOnMove parameters): interpolated soft scratches + gold flakes + coin cursor + hide the hint on press ── */
    var fx = null;
    function fxLayer() {
      if (fx && fx.parentNode) return fx;
      var host = root.querySelector('.dn-pop__scratch');
      if (!host) return null;
      fx = document.createElement('div');
      fx.setAttribute('aria-hidden', 'true');
      fx.style.cssText = 'position:absolute;inset:0;z-index:7;pointer-events:none;overflow:visible;';
      host.appendChild(fx);
      return fx;
    }
    function popFlakes(x, y) {
      var layer = fxLayer(); if (!layer) return;
      var n = 1 + (Math.random() < 0.6 ? 1 : 0);
      for (var i = 0; i < n; i++) {
        var cw = 2 + Math.random() * 3.2, ch = 4 + Math.random() * 6;
        var tone = ['#D8C6A2', '#C4AF88', '#E6D9BE', '#B69C6F'][(Math.random() * 4) | 0];
        var curl = Math.random() < 0.5 ? '46% 54% 52% 48% / 40% 42% 58% 60%' : '2px';
        var f = document.createElement('span');
        f.style.cssText = 'position:absolute;left:' + (x - cw / 2) + 'px;top:' + (y - ch / 2) + 'px;width:' + cw + 'px;height:' + ch + 'px;background:linear-gradient(155deg,' + tone + ',rgba(120,96,52,0.35));border-radius:' + curl + ';box-shadow:0 1px 1px rgba(0,0,0,0.18);';
        layer.appendChild(f);
        var dx = (Math.random() - 0.5) * 50, dy = 24 + Math.random() * 48, rot = (Math.random() - 0.5) * 340;
        f.animate([{ transform: 'translate(0,0) rotate(0)', opacity: 1 }, { transform: 'translate(' + dx + 'px,' + dy + 'px) rotate(' + rot + 'deg)', opacity: 0 }], { duration: 480 + Math.random() * 280, easing: 'cubic-bezier(0.3,0.7,0.4,1)' }).onfinish = function () { f.remove(); };
      }
    }
    var scr = { on: false, last: null };
    if (canvas) {
      canvas.addEventListener('pointerdown', function (e) {
        if (!mq.matches) return;
        scr.on = true; scr.last = null;
        if (drag) drag.style.display = 'none';
      });
      canvas.addEventListener('pointermove', function (e) {
        if (!mq.matches || !scr.on) return;
        var rct = canvas.getBoundingClientRect();
        var p = { x: e.clientX - rct.left, y: e.clientY - rct.top };
        var ctx = canvas.getContext('2d');
        ctx.globalCompositeOperation = 'destination-out';
        var r = 22, pts = [];
        if (scr.last) {
          var dist = Math.hypot(p.x - scr.last.x, p.y - scr.last.y);
          var steps = Math.max(1, Math.ceil(dist / (r * 0.3)));
          for (var i = 1; i <= steps; i++) { var t = i / steps; pts.push({ x: scr.last.x + (p.x - scr.last.x) * t, y: scr.last.y + (p.y - scr.last.y) * t }); }
        } else pts.push(p);
        for (var j = 0; j < pts.length; j++) {
          popStamp(ctx, pts[j].x + (Math.random() - 0.5) * 5, pts[j].y + (Math.random() - 0.5) * 5, r * (0.8 + Math.random() * 0.34));
        }
        scr.last = p;
        popFlakes(p.x, p.y);
        if (Math.random() < 0.7) popFlakes(p.x + (Math.random() - 0.5) * 30, p.y + (Math.random() - 0.5) * 20);
      });
      ['pointerup', 'pointercancel'].forEach(function (ev) {
        canvas.addEventListener(ev, function () { scr.on = false; scr.last = null; });
      });
    }

    /* ── reveal celebration (design _popBurst / _popShine / _popConfetti / _popAnimateCount parameters) ── */
    function celebrate() {
      var layer = fxLayer(); if (!layer) return;
      var rct = canvas ? canvas.getBoundingClientRect() : { width: 400, height: 250 };
      var W = rct.width || 400, H = rct.height || 250;
      var b = document.createElement('span');
      b.style.cssText = 'position:absolute;left:' + (W / 2) + 'px;top:' + (H / 2) + 'px;width:36px;height:36px;margin:-18px 0 0 -18px;border-radius:50%;background:radial-gradient(circle,rgba(255,255,255,0.55),rgba(255,255,255,0) 70%);';
      layer.appendChild(b);
      b.animate([{ transform: 'scale(0.4)', opacity: 1 }, { transform: 'scale(4)', opacity: 0 }], { duration: 650, easing: 'cubic-bezier(0.15,0.7,0.3,1)' }).onfinish = function () { b.remove(); };
      var wrap = document.createElement('div');
      wrap.style.cssText = 'position:absolute;inset:0;overflow:hidden;';
      var bar = document.createElement('span');
      bar.style.cssText = 'position:absolute;top:0;left:-40%;width:40%;height:100%;background:linear-gradient(100deg,rgba(255,255,255,0),rgba(255,255,255,0.55),rgba(255,255,255,0));transform:skewX(-16deg);';
      wrap.appendChild(bar); layer.appendChild(wrap);
      bar.animate([{ transform: 'translateX(0) skewX(-16deg)' }, { transform: 'translateX(370%) skewX(-16deg)' }], { duration: 750, delay: 120, easing: 'cubic-bezier(0.25,0.7,0.3,1)' }).onfinish = function () { wrap.remove(); };
      var cols = ['#C9B694', '#FBFBFB', '#2D2D2D', '#B08D57'];
      for (var i = 0; i < 38; i++) {
        (function () {
          var pconf = document.createElement('span');
          var w = 4 + Math.random() * 5, h = 7 + Math.random() * 9;
          pconf.style.cssText = 'position:absolute;left:' + (W / 2) + 'px;top:' + (H / 2) + 'px;width:' + w + 'px;height:' + h + 'px;background:' + cols[i % 4] + ';border-radius:1px;box-shadow:0 1px 2px rgba(0,0,0,0.15);';
          layer.appendChild(pconf);
          var ang = Math.random() * 6.283, dist = 70 + Math.random() * 150;
          var dx = Math.cos(ang) * dist, dy = Math.sin(ang) * dist - 30 + Math.random() * 100;
          pconf.animate([{ transform: 'translate(-50%,-50%) rotate(0)', opacity: 1 }, { transform: 'translate(calc(-50% + ' + dx + 'px),calc(-50% + ' + dy + 'px)) rotate(' + ((Math.random() - 0.5) * 700) + 'deg)', opacity: 0 }], { duration: 800 + Math.random() * 440, easing: 'cubic-bezier(0.15,0.7,0.3,1)' }).onfinish = function () { pconf.remove(); };
        })();
      }
      for (var k = 0; k < 10; k++) {
        (function () {
          var sp = document.createElement('span');
          var sz = 4 + Math.random() * 3;
          sp.style.cssText = 'position:absolute;left:' + (W / 2) + 'px;top:' + (H / 2) + 'px;width:' + sz + 'px;height:' + sz + 'px;border-radius:50%;background:#FBFBFB;box-shadow:0 0 6px 1px rgba(255,255,255,0.8);';
          layer.appendChild(sp);
          var ang = Math.random() * 6.283, dist = 55 + Math.random() * 130;
          var dx = Math.cos(ang) * dist, dy = Math.sin(ang) * dist - 18 + Math.random() * 80;
          sp.animate([{ transform: 'translate(-50%,-50%) scale(1)', opacity: 1 }, { transform: 'translate(calc(-50% + ' + dx + 'px),calc(-50% + ' + dy + 'px)) scale(0.3)', opacity: 0 }], { duration: 650 + Math.random() * 380, easing: 'cubic-bezier(0.15,0.7,0.3,1)' }).onfinish = function () { sp.remove(); };
        })();
      }
      /* prize number roll (when the offer copy looks like "10% ...": 0→N easeOut 700ms) */
      var offer = root.querySelector('.dn-pop__offer');
      if (offer) {
        var m = (offer.textContent || '').match(/^(\d+)%([\s\S]*)$/);
        if (m) {
          var target = parseInt(m[1], 10), suffix = m[2], t0 = performance.now();
          (function stepc(now) {
            var pr = Math.min(1, (now - t0) / 700), eased = 1 - Math.pow(1 - pr, 3);
            offer.textContent = Math.round(target * eased) + '%' + suffix;
            if (pr < 1) requestAnimationFrame(stepc);
          })(t0);
        }
      }
    }

    /* scratched (canvas fades out) → hide the hint + celebrate + hang tag permanently in the revealed state */
    var celebrated = false;
    if (canvas) new MutationObserver(function () {
      if (canvas.style.opacity === '0') {
        if (drag) drag.style.display = 'none';
        if (mq.matches && !celebrated) { celebrated = true; celebrate(); setTimeout(function () { celebrated = false; }, 1500); }
        markPopRevealed(); /* scratched once: the hang tag switches to "revealed" for good (survives reloads) */
      }
    }).observe(canvas, { attributes: true, attributeFilter: ['style'] });
  }

  /* ── cart 1:1 mirror layer (count / Held / progress track / delivery / chips) ── */
  function cartSkinInit() {
    var drawer = $('#cart-drawer'); if (!drawer) return;
    /* Gap, progress and threshold come from window.dnFsCompute (null when the threshold
       setting or the currency rate is missing: then nothing is drawn, no number is invented). */
    function fsCompute(c) { return typeof window.dnFsCompute === 'function' ? window.dnFsCompute(c) : null; }
    function fsMoney(cents) { return typeof window.themeFormatMoney === 'function' ? window.themeFormatMoney(cents) : null; }
    var msShipAmt = $('[data-dn3-ms-ship-amt]');
    var fs0 = fsCompute({ total_price: 0 });
    if (msShipAmt && fs0 && fsMoney(fs0.thresholdDisplayCents)) msShipAmt.textContent = fsMoney(fs0.thresholdDisplayCents);
    var msShip = $('[data-dn3-ms-ship]');

    /* item count mirror */
    var srcCount = $('.cart-drawer__header [data-cart-count]');
    var outN = $('[data-dn3-cart-nitems]');
    function runCount() {
      if (!srcCount || !outN) return;
      var m = (srcCount.textContent || '').match(/\d+/);
      var n = m ? parseInt(m[0], 10) : 0;
      outN.textContent = n + (n === 1 ? ' ITEM' : ' ITEMS');
    }
    runCount();
    if (srcCount) new MutationObserver(runCount).observe(srcCount, { childList: true, characterData: true, subtree: true });

    /* Held countdown mirror (the original urgency bar is hidden but still running) */
    var urg = $('#cart-urgency'), heldWrap = $('[data-dn3-cart-held]'), heldT = $('[data-dn3-cart-held-t]');
    function runHeld() {
      if (!urg || !heldWrap) return;
      var vis = urg.style.display !== 'none';
      var m = (urg.textContent || '').match(/(\d{1,2}:\d{2})/);
      heldWrap.style.display = vis && m ? 'inline-flex' : 'none';
      if (m && heldT) heldT.textContent = m[1];
    }
    runHeld();
    if (urg) new MutationObserver(runHeld).observe(urg, { childList: true, characterData: true, subtree: true, attributes: true });

    /* Free-shipping progress track (driven by the real /cart.js; the track ends at the threshold). */
    var outText = $('[data-dn3-ship-text]');
    var outFill = $('[data-dn3-ship-fill]');
    var shipZone = $('[data-dn3-cart-ship]');
    function renderShip(c) {
      var fs = fsCompute(c);
      var gapTxt = fs && fsMoney(fs.gapCents), thrTxt = fs && fsMoney(fs.thresholdDisplayCents);
      if (!fs || !gapTxt || !thrTxt) return;
      var shipDone = fs.gapCents <= 0;
      if (outFill) outFill.style.width = fs.pct + '%';
      if (msShip) msShip.classList.toggle('is-hit', shipDone);
      if (shipZone) shipZone.classList.toggle('is-shipdone', shipDone);
      var shipSub = msShip && msShip.querySelector('.dn3-cart-ship__mslabel b');
      if (shipSub) shipSub.textContent = shipDone ? 'Unlocked' : thrTxt;
      if (outText) {
        if (!shipDone) window.DuniiiCartShippingCopy.render(outText, 'remaining', "You're {amount} from free shipping", gapTxt, thrTxt);
        else window.DuniiiCartShippingCopy.render(outText, 'unlocked', "You've unlocked free shipping!", gapTxt, thrTxt, true);
      }
    }
    var shipBusy = false;
    function runShip() {
      if (shipBusy) return; shipBusy = true;
      fetch(route('cart.js'), { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
        shipBusy = false;
        renderShip(c);
        try { giftSync(c); } catch (e) {}
      }).catch(function () { shipBusy = false; });
    }
    runShip();
    /* Estimated total + You save mirror (design right column: gold save text on top · 42px price below) */
    var totalOut = $('[data-dn3-total]'), saveWrap = $('[data-dn3-save]'), saveAmt = $('[data-dn3-save-amt]');
    var savEl = $('#cart-savings'), savAmtSrc = $('[data-cart-savings-amount]');
    function totalMirror() {
      var subEl2 = $('#cart-subtotal');
      if (totalOut && subEl2) totalOut.textContent = (subEl2.textContent || '').trim() || '$0.00';
      if (saveWrap && savEl) {
        var vis = savEl.style.display !== 'none';
        if (saveAmt && savAmtSrc) saveAmt.textContent = (savAmtSrc.textContent || '').trim();
        saveWrap.style.display = vis && saveAmt && saveAmt.textContent ? 'block' : 'none';
      }
    }
    totalMirror();
    if (savEl) new MutationObserver(totalMirror).observe(savEl, { attributes: true, childList: true, characterData: true, subtree: true });
    var subEl = $('#cart-subtotal');
    if (subEl) new MutationObserver(function () { totalMirror(); setTimeout(runShip, 150); }).observe(subEl, { childList: true, characterData: true, subtree: true });

    /* desktop Remove link (the design line has it; click = the theme's own minus pipeline down to 0) */
    var itemsBox = $('#cart-drawer-items');
    function injectRemoves() {
      if (!mq.matches || !itemsBox) return;
      $all('.cart-item', itemsBox).forEach(function (row) {
        if (row.querySelector('.dn3-cart-remove')) return;
        var qtyBox = row.querySelector('.cart-item__qty');
        if (!qtyBox) return;
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'dn3-d dn3-cart-remove'; b.textContent = 'Remove';
        qtyBox.parentNode.insertBefore(b, qtyBox.nextSibling);
        b.addEventListener('click', function () {
          /* remove the whole line in one click: the theme pipeline sends /cart/change.js with "current quantity text - 1" —
             set the text to 1 for a moment, then trigger the native minus: one POST quantity:0 and a self-refresh */
          var dec = row.querySelector('[data-action="decrease"]');
          var val = row.querySelector('.cart-item__qty-value');
          if (!dec) return;
          if (val) val.textContent = '1';
          dec.click();
        });
      });
    }
    injectRemoves();
    if (itemsBox) new MutationObserver(function () { setTimeout(injectRemoves, 80); }).observe(itemsBox, { childList: true, subtree: true });
    if (mq.addEventListener) mq.addEventListener('change', function (e) { if (e.matches) injectRemoves(); });

    /* delivery dates (+7 to +15 days, same parameters as the journey) */
    var arr = $('[data-dn3-cart-arrives]');
    if (arr) {
      function fmt(d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
      var day = 864e5, now = Date.now();
      arr.textContent = fmt(new Date(now + 3 * day)) + ' – ' + fmt(new Date(now + 6 * day));
    }

    /* MAKE IT YOURS chips (all on the real backend: note → cart.note / gift → real add of the wrap product + Gift message attribute / code → discount cookie) */
    var noteSlot = $('[data-dn3-note-slot]');
    var giftPanel = $('[data-dn3-gift-panel]');
    var codeWrap = $('[data-dn3-code-wrap]');
    function post(url, body) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }).then(function (r) { if (!r.ok) throw r; return r.json(); });
    }
    function drawerRefresh() {
      var o = $('.site-header [data-cart-open]');
      if (o) o.click(); /* theme open() is idempotent: reopening = refresh + re-render */
    }
    var panels = { note: [noteSlot, 'block'], gift: [giftPanel, 'block'], code: [codeWrap, 'flex'] };
    drawer.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-dn3-chip]');
      if (!chip) return;
      var kind = chip.getAttribute('data-dn3-chip');
      var p = panels[kind]; if (!p || !p[0]) return;
      var wasOpen = p[0].style.display !== 'none';
      Object.keys(panels).forEach(function (k) {
        if (panels[k][0]) panels[k][0].style.display = 'none';
        var c = $('[data-dn3-chip="' + k + '"]'); if (c) c.classList.remove('is-open');
      });
      if (!wasOpen) {
        p[0].style.display = p[1];
        chip.classList.add('is-open');
        var focusEl = kind === 'note' ? $('[data-dn3-note-ta]') : (kind === 'code' ? $('[data-dn3-code-input]') : null);
        if (focusEl) setTimeout(function () { focusEl.focus(); }, 60);
      }
    });

    /* Note: saved as typed (600ms debounce → /cart/update.js note; "Saved" shows after the read-back confirms) */
    var noteTa = $('[data-dn3-note-ta]'), noteState = $('[data-dn3-note-state]'), noteTimer = null;
    function pushNote() {
      if (!noteTa) return;
      var v = noteTa.value;
      post(route('cart/update.js'), { note: v }).then(function (c) {
        if (noteState) {
          noteState.textContent = (c.note || '') === v ? 'Saved to your order ✓' : 'Saved';
          noteState.style.display = 'block';
        }
        var chip = $('[data-dn3-chip="note"]'); if (chip) chip.classList.toggle('is-on', !!v.trim());
      }).catch(function () {});
    }
    if (noteTa) noteTa.addEventListener('input', function () {
      if (noteState) noteState.style.display = 'none';
      clearTimeout(noteTimer); noteTimer = setTimeout(pushNote, 600);
    });

    /* Gift: pick a card → real add of the wrap product; the message goes into the Gift message attribute; click again to remove */
    var giftAdd = $('[data-dn3-gift-add]'), giftRm = $('[data-dn3-gift-remove]'), giftMsg = $('[data-dn3-gift-msg]');
    function giftIds() { return $all('[data-dn3-gift-opt]').map(function (c) { return c.getAttribute('data-variant'); }); }
    function giftSelected() { return $('[data-dn3-gift-opt].is-selected') || $('[data-dn3-gift-opt]'); }
    function giftBtnLabel() {
      if (!giftAdd) return;
      var card = giftSelected(); if (!card) return;
      var p = parseInt(card.getAttribute('data-price') || '0', 10);
      giftAdd.textContent = 'Add gift wrap' + (p > 0 ? ' · +$' + (p / 100).toFixed(2) : ' · Free');
    }
    $all('[data-dn3-gift-opt]').forEach(function (card) {
      card.addEventListener('click', function () {
        $all('[data-dn3-gift-opt]').forEach(function (c) { c.classList.remove('is-selected'); });
        card.classList.add('is-selected');
        giftBtnLabel();
      });
    });
    giftBtnLabel();
    function giftSync(c) {
      var ids = giftIds();
      var line = ids.length ? (c.items || []).filter(function (it) { return ids.indexOf(String(it.variant_id)) > -1; })[0] : null;
      var attrOn = !ids.length && c.attributes && c.attributes['Gift wrap'] === 'Yes';
      var on = !!line || attrOn;
      var chip = $('[data-dn3-chip="gift"]');
      if (chip) chip.classList.toggle('is-on', on);
      if (giftRm) giftRm.style.display = on ? 'inline' : 'none';
      if (giftAdd) giftAdd.style.display = on ? 'none' : 'block';
      if (line) $all('[data-dn3-gift-opt]').forEach(function (c2) { c2.classList.toggle('is-selected', String(line.variant_id) === c2.getAttribute('data-variant')); });
    }
    if (giftAdd) giftAdd.addEventListener('click', function () {
      var card = giftSelected();
      var msg = giftMsg ? giftMsg.value.trim() : '';
      giftAdd.disabled = true;
      var attrs = { 'Gift wrap': 'Yes' }; if (msg) attrs['Gift message'] = msg;
      var flow = card
        ? post(route('cart/add.js'), { items: [{ id: parseInt(card.getAttribute('data-variant'), 10), quantity: 1 }] })
            .then(function () { return msg ? post(route('cart/update.js'), { attributes: { 'Gift message': msg } }) : null; })
        : post(route('cart/update.js'), { attributes: attrs }); /* fallback when no wrap product is configured: an attribute marker (also reaches the order) */
      flow.then(function () {
        giftAdd.disabled = false;
        if (!card) { var chip = $('[data-dn3-chip="gift"]'); if (chip) chip.classList.add('is-on'); if (giftRm) giftRm.style.display = 'inline'; if (giftAdd) giftAdd.style.display = 'none'; }
        drawerRefresh();
      }).catch(function () { giftAdd.disabled = false; });
    });
    if (giftRm) giftRm.addEventListener('click', function () {
      var jobs = giftIds().map(function (id) { return post(route('cart/change.js'), { id: id, quantity: 0 }).catch(function () {}); });
      Promise.all(jobs)
        .then(function () { return post(route('cart/update.js'), { attributes: { 'Gift message': '', 'Gift wrap': '' } }); })
        .then(function () {
          var chip = $('[data-dn3-chip="gift"]'); if (chip) chip.classList.remove('is-on');
          if (giftRm) giftRm.style.display = 'none'; if (giftAdd) giftAdd.style.display = 'block';
          drawerRefresh();
        }).catch(drawerRefresh);
    });

    /* Code: /discount/ writes the checkout discount cookie; button state feedback */
    var applyBtn = $('[data-dn3-code-apply]');
    if (applyBtn) applyBtn.addEventListener('click', function () {
      var ci = $('[data-dn3-code-input]');
      var code = ci && ci.value.trim();
      if (!code) return;
      applyBtn.disabled = true;
      fetch(route('discount/' + encodeURIComponent(code))).then(function () {
        applyBtn.textContent = 'Applied ✓';
        var chip = $('[data-dn3-chip="code"]'); if (chip) chip.classList.add('is-on');
      }).catch(function () { applyBtn.disabled = false; });
    });

    /* fill state when the drawer opens (real backend read: note / gift lines) */
    fetch(route('cart.js'), { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
      if (noteTa && c.note) {
        noteTa.value = c.note;
        var chip = $('[data-dn3-chip="note"]'); if (chip) chip.classList.add('is-on');
      }
      giftSync(c);
    }).catch(function () {});

    /* no flash when opening an empty bag: recs left from the last non-empty bag would show ~450ms until the theme re-renders.
       At the open moment the header badge decides empty; an empty bag hides recs at once (non-empty: no action, the theme render manages it) */
    new MutationObserver(function () {
      if (!mq.matches || !drawer.classList.contains('is-open')) return;
      var badge = document.querySelector('.site-header [data-cart-count]');
      var n = badge ? parseInt(badge.textContent, 10) || 0 : 0;
      /* v4 (099 2f, ENGINE-CONTRACT §6.5): a skin that declares data-cart-empty-keep="...recs..." on #cart-drawer
         keeps its recommendations on an empty bag, so they are not hidden here; no declaration = v3 behaviour. */
      if (!n && !emptyKeeps(drawer, 'recs')) {
        var rc = document.getElementById('cart-recs');
        if (rc) rc.style.display = 'none';
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

    /* instant load: on desktop every lazy image in the drawer switches to eager prefetch (cache hit when the drawer opens) */
    function warmImgs() {
      if (!mq.matches) return;
      $all('#cart-drawer-items img, #cart-recs img, .dn3-cart-gift__card img', drawer).forEach(function (im) {
        if (im.getAttribute('loading') === 'lazy') im.setAttribute('loading', 'eager');
        if (!im.complete && im.src) { var pre = new Image(); pre.src = im.src; }
      });
    }
    warmImgs();
    new MutationObserver(function () { setTimeout(warmImgs, 60); }).observe(drawer, { childList: true, subtree: true });
  }

  function boot() {
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
    cartBadge(); megaInit(); dwInit(); tagInit(); popInit(); cartSkinInit();
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-dn3-cart-open]')) {
        var o = $('.site-header [data-cart-open]');
        if (o) o.click();
      }
    });
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
